import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import React from "react";
import tokens from "@/theme/tokens";

const RebelFormLabel = styled((props) => (
  <Typography
    variant="h6"
    {...props}
    component="label"
    htmlFor={props.htmlFor}
  />
))(() => ({
  marginBottom: tokens.space.px5,
  marginTop: tokens.space.px15,
  display: "block",
  fontWeight: "bold",
  fontSize: tokens.fontSize.hubFormLabel,
}));

export default React.memo(RebelFormLabel);
